export const FPTypography = {
  fontFamilyHeader: '"IBM Plex Sans", sans-serif',
  fontFamilyContent: '"Inter Tight", sans-serif',
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
  }
};
